import { Fragment, useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ChooseBankAccountForOrder from "../../../../components/Shipment/CODRequest/ChooseBankAccountForOrder";
import { postRequestByAuth } from "../../../../function/helper";
import useSharedData from "../../../../hooks/useSharedData";
import ModalRules from "../../newLetter/components/order/ModalRules";
import doSubmit from "../functions/doSubmit";
import getCompany from "../functions/getCompany";
import getSenderAddress from "../functions/getSenderAddress";
import isCodFunction from "../functions/isCod";

function DetailBox({ shipments, reset, formValues, prices, setPrices }) {
  const [modalRules, setModalRules] = useState(false);
  const [modalBankAccount, setModalBankAccount] = useState(false);

  const isRate = () => {
    if (prices.length === 0) return true;
    if (shipments.length !== prices.length) return true;
    for (const item of prices) {
      if (item.price === 0) return true;
    }

    return false;
  };

  const navigate = useNavigate();

  const senderAddress = getSenderAddress();
  const { isAgent } = useSharedData();
  const isCod = isCodFunction();

  const [details, setDetails] = useState({
    needSMS: false,
    needPrint: isAgent,
    needCollecting: isAgent,
    requirePackaging: false,
  });

  useEffect(() => {
    const hasAnyShipmentPackaging = shipments.filter(
      item => item.needPackaging === true
    );
    const requirePackaging = hasAnyShipmentPackaging.length > 0;

    setDetails(cur => ({
      ...cur,
      needPrint: requirePackaging ? true : cur.needPrint,
      needCollecting: requirePackaging ? true : cur.needCollecting,
      requirePackaging: requirePackaging,
    }));
  }, [shipments.map(item => item.needPackaging).join("|"), isCod]);

  const [loading, setLoading] = useState([false, false]);

  useEffect(() => {
    if (formValues.count === 0) {
      return;
    }
    const values = formValues.values;

    reset(values);
    doSubmit({
      values,
      set: data => setPrices([...data]),
      setLoading: state =>
        setLoading(cur => {
          cur[0] = state;
          return [...cur];
        }),
      needPrint: details.needPrint,
      needSMS: details.needSMS,
      collectingType: 1,
      needCollecting: details.needCollecting,
    });
  }, [formValues.count]);

  const getPrice = ui => {
    return prices.find(item => item.ui === ui).price;
  };

  const submit = async () => {
    setLoading(cur => {
      cur[1] = true;
      return [...cur];
    });

    const data = {
      senderAddressId: senderAddress.id,
      company: getCompany().selected,
      isCod,
      shipments: shipments.map(item => ({ ...item, price: getPrice(item.ui) })),
      collectingType: 1,
      internalSectionId: 1,
      ...details,
    };

    const response = await postRequestByAuth("/internalpost/v1/bulk/add", data);

    setLoading(cur => {
      cur[1] = false;
      return [...cur];
    });

    if (response.status === 200) {
      Swal.fire({
        icon: "success",
        text: response.data.message,
        confirmButtonText: "مشاهده پیش فاکتور",
      }).then(() => {
        navigate(`/prefactor/${response.data.data}`);
      });
    } else {
      Swal.fire({
        icon: "error",
        text: response.data.message,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "gray",
      });
    }
  };

  const handleBankAccountAndRules = () => {
    const totalAmountCOD = shipments.reduce(
      (sum, item) => item.amountCOD + sum,
      0
    );
    if (totalAmountCOD > 0) {
      setModalBankAccount(true);
      return;
    }

    setModalRules(true);
  };

  return (
    <div className="d-flex flex-column gap-3">
      <h5 className="mb-0">تعیین جزئیات سفارش</h5>

      {!isAgent && (
        <div className="d-flex align-item-center">
          <input
            type="checkbox"
            id="yuT45gRs"
            className="d-inline-block"
            checked={details.needCollecting}
            disabled={details.requirePackaging || details.needPrint}
            style={{ width: 25, height: 25 }}
            onChange={e => {
              setDetails(cur => ({
                ...cur,
                needCollecting: e.target.checked,
                needPrint: e.target.checked === true ? cur.needPrint : false,
              }));
              setPrices([]);
            }}
          />
          <Form.Label
            className="d-inline-block mx-2 my-0 c-pointer"
            htmlFor="yuT45gRs"
          >
            نیاز به جمع آوری دارم
          </Form.Label>
        </div>
      )}

      <section className="d-flex align-item-center">
        <input
          type="checkbox"
          id="asyT89Sz"
          className="d-inline-block c-pointer"
          checked={details.needSMS}
          style={{ width: 25, height: 25 }}
          onChange={e => {
            setDetails(cur => ({ ...cur, needSMS: e.target.checked }));
            setPrices([]);
          }}
        />
        <Form.Label
          className="d-inline-block mx-2 my-0 c-pointer"
          htmlFor="asyT89Sz"
        >
          درخواست دریافت پیامک در مراحل ارسال را دارم
        </Form.Label>
      </section>

      <section className="d-flex align-item-center">
        <input
          type="checkbox"
          id="lksdye564"
          checked={details.needPrint}
          disabled={
            details.requirePackaging || details.needCollecting === false
          }
          className="d-inline-block c-pointer"
          style={{ width: 25, height: 25 }}
          onChange={e => {
            setDetails(cur => ({ ...cur, needPrint: e.target.checked }));
            setPrices([]);
          }}
        />
        <Form.Label
          className="d-inline-block mx-2 my-0 c-pointer"
          htmlFor="lksdye564"
        >
          نیاز به پرینت فاکتور توسط آواکس را دارم
        </Form.Label>
      </section>

      <div className="mt-3">
        {isRate() ? (
          <Fragment>
            {loading[0] === true && (
              <button
                type="button"
                className="buttonUi btn-orange-header-button"
              >
                <div className="d-flex align-items-center px-4">
                  <Spinner
                    style={{
                      width: "20px",
                      height: "20px",
                      fontSize: "0.8rem",
                    }}
                  />
                  <span className="me-3"> در حال استعلام</span>
                </div>
              </button>
            )}

            {loading[0] === false && (
              <button
                type="submit"
                id="formShop"
                className="buttonUi text-center btn-orange-header-button"
              >
                <span>استعلام قیمت</span>
              </button>
            )}
          </Fragment>
        ) : (
          <Fragment>
            {loading[1] === true && (
              <button
                type="button"
                className="buttonUi text-center btn-success-style"
              >
                <div className="d-flex align-items-center">
                  <Spinner
                    style={{
                      width: "20px",
                      height: "20px",
                      fontSize: "0.8rem",
                    }}
                  />
                  <span className="me-3"> در حال ثبت</span>
                </div>
              </button>
            )}

            {loading[1] === false && (
              <button
                type="button"
                onClick={handleBankAccountAndRules}
                className="buttonUi text-center btn-success-style"
              >
                <span>ثبت نهایی سفارش</span>
              </button>
            )}
          </Fragment>
        )}
      </div>

      {modalRules && (
        <ModalRules close={() => setModalRules(false)} sumbit={submit} />
      )}

      {modalBankAccount && (
        <ChooseBankAccountForOrder
          onClose={() => setModalBankAccount(false)}
          senderAddressId={senderAddress?.id}
          onChoose={value => {
            setModalBankAccount(false);
            setDetails(cur => ({ ...cur, bankAccountId: value.id }));
            setModalRules(true);
          }}
        />
      )}
    </div>
  );
}

export default DetailBox;
